import React from "react";

import { Button, message, Tooltip } from "antd";
import BookLockerBoxModal from "./book-locker-box-modal";

class SendToLockerButton extends React.Component {

    constructor( props ){
        super(props);

        this.state = {
            showModal: false,
            modalKey: this.getModalKey()
        };
    }

    render() {

        const { selectedLocationsData } = this.props;

        return (
            <div>

                <BookLockerBoxModal 
                    selectedLocationsData={selectedLocationsData}
                    key={ this.state.modalKey }
                    onCancel={ this.onClickCloseModal }
                    visible={this.isModalVisible()}
                    />

                <Tooltip
                    visible={this.getPickupCount() > 0}
                    title="Unselect Pickup Jobs to enable">
                    <Button 
                        onClick={ this.onClickSendToEzLockerButton }
                        size="large" 
                        disabled={this.isDisabled()} 
                        type="danger">
                        Send to EZ Locker
                    </Button>
                </Tooltip>
                
            </div>
        );
    }

    isDisabled = () => {

        let buttonIsDisabled = false;

        // if selected jobs that already has a booking
        let jobsThatAlreadyHasBookingCount = this.props.selectedLocationsData.filter(
            _location => {
                return _location.iotLockerBoxBookingId
            }
        ).length;
        if( jobsThatAlreadyHasBookingCount > 0 ){
            buttonIsDisabled = true;
        }

        // if non eezee send delivery mode selected
        let nonEezeeSendCount = this.props.selectedLocationsData.filter(
            _location => {
                return _location.deliveryMode !== "Eezee Send"
            }
        ).length;
        if (nonEezeeSendCount > 0) {
            buttonIsDisabled = true;
        }

        // if no locations selected
        let locationsSelectedCount = this.props.selectedLocationsData.length;
        if (locationsSelectedCount === 0) {
            buttonIsDisabled = true;
        }

        // if selected pickup jobs
        if (this.getPickupCount() > 0) {
            buttonIsDisabled = true;
        }

        return buttonIsDisabled;

    }

    isModalVisible = () => {

        let { showModal } = this.state;

        return showModal && !this.isDisabled();

    }

    getModalKey = () => {
        return parseInt(Math.random() * 10000);
    }

    getPickupCount = () => {
        return this.props.selectedLocationsData.filter(_location => {
            return _location.locationActionRequired === "pickup"
        }).length
    }

    onClickCloseModal = () => {
        this.setState({
            showModal: false
        });
    }

    onClickSendToEzLockerButton = () => {

        if( this.isDisabled() ){
            return message.error("Button is disabled");
        }

        this.setState({
            showModal: true,
            modalKey: this.getModalKey()
        });

    }

}

export default SendToLockerButton;


// WEBPACK FOOTER //
// ./src/components/delivery-page/send-to-locker-button.js